"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClinicianCalendar = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
var _react = _interopRequireWildcard(require("react"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _reactUse = require("react-use");
var _react2 = _interopRequireDefault(require("@fullcalendar/react"));
var _timegrid = _interopRequireDefault(require("@fullcalendar/timegrid"));
var _momentTimezone2 = _interopRequireDefault(require("@fullcalendar/moment-timezone"));
require("./ClinicianCalendar.less");
var _utils = require("../../utils");
var _ = require("./..");
var _utils2 = require("./utils");
var _components = require("./components");
var _types = require("../../types");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
// Static config to avoid unnecessary <FullCalendar /> re-renders (without useMemo / useCallback)
// which have been observed to cause unintended side effects (e.g. infinite loops, UI flickering)
// https://fullcalendar.io/docs
// https://fullcalendar.io/docs/react
var fcConfig = {
  plugins: [_momentTimezone2.default, _timegrid.default],
  buttonText: {
    today: 'Today'
  },
  headerToolbar: {
    start: 'today prev,next',
    center: 'title',
    end: 'timeZone'
  },
  height: '100%',
  validRange: function validRange(today) {
    return {
      start: (0, _momentTimezone.default)(today).startOf('week').toDate(),
      end: (0, _momentTimezone.default)(today).startOf('week').add(6, 'months').add(2, 'weeks').toDate()
    };
  }
};
var ClinicianCalendar = function ClinicianCalendar(_ref) {
  var clinician = _ref.clinician,
    calendarRef = _ref.calendarRef,
    refreshCalendar = _ref.refreshCalendar;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    fetching = _useState2[0],
    setFetching = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    currentEndDate = _useState4[0],
    setCurrentEndDate = _useState4[1];
  var _useSet = (0, _reactUse.useSet)(new Set([_utils2.CalendarGroup.BlockingEvents, _utils2.CalendarGroup.MonumentAppointments, _utils2.CalendarGroup.RecurringAvailability, _utils2.CalendarGroup.DateBasedAvailability])),
    _useSet2 = _slicedToArray(_useSet, 2),
    showCalendars = _useSet2[0],
    showCalendarsSet = _useSet2[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    blockingCalendarIds = _useState6[0],
    setBlockingCalendarIds = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    appointmentToExtend = _useState8[0],
    setAppointmentToExtend = _useState8[1];
  var _useRequest = (0, _utils.useRequest)((0, _utils.getClinicianCalendarsUrl)(clinician.id)),
    calendars = _useRequest.data,
    loadingCalendars = _useRequest.loading;
  var isBlockingCalendar = function isBlockingCalendar(calendarId) {
    // If blocking calendars are not specified, then events from all calendars are blocking
    if (blockingCalendarIds.length === 0) {
      return true;
    }
    return blockingCalendarIds.includes(calendarId);
  };
  var blockingCalendars = (calendars || []).filter(function (calendar) {
    return isBlockingCalendar(calendar.calendarId);
  });
  var handleDatesSet = (0, _react.useCallback)(function (dateInfo) {
    setCurrentEndDate(dateInfo.end);
  }, []);
  var customButtons = (0, _react.useMemo)(function () {
    return {
      // Unfortunately there's no easy way to inject dynamic content into the header, so we just
      // use a button for now (can't disable the button either but w/e).
      timeZone: {
        text: (0, _utils2.getClinicianCalendarTimeZoneText)(clinician.timeZone, currentEndDate)
      }
    };
  }, [clinician.timeZone, currentEndDate]);
  var eventSources = (0, _react.useMemo)(function () {
    return [{
      url: (0, _utils.getClinicianBlockingEventsUrl)(clinician.id, {
        attachPatientData: true
      }),
      id: _utils2.CalendarGroup.CalendarEvents,
      eventDataTransform: function eventDataTransform(eventData) {
        var calendarGroup = eventData.isAppointment ? _utils2.CalendarGroup.MonumentAppointments : _utils2.CalendarGroup.BlockingEvents;
        var inFuture = (0, _momentTimezone.default)(eventData.start).isAfter((0, _momentTimezone.default)());
        return _objectSpread(_objectSpread({}, eventData), {}, {
          color: _utils2.ColorForCalendarGroup[calendarGroup],
          calendarGroup: calendarGroup,
          startsAt: eventData.start,
          extendBooking: inFuture && eventData.isAppointment && (0, _utils.needToExtendBooking)({
            clinician: clinician,
            status: _types.BookingStatus.Scheduled,
            duration: (0, _momentTimezone.default)(eventData.end).diff(eventData.start, 'minutes')
          })
        });
      }
    }, {
      url: (0, _utils.getClinicianAvailablePeriodsUrl)(clinician.id),
      id: _utils2.CalendarGroup.DateBasedAvailability,
      color: _utils2.ColorForCalendarGroup[_utils2.CalendarGroup.DateBasedAvailability],
      display: 'background',
      eventDataTransform: function eventDataTransform(event) {
        return _objectSpread(_objectSpread({}, event), {}, {
          calendarGroup: _utils2.CalendarGroup.DateBasedAvailability
        });
      }
    }, {
      url: (0, _utils.getClinicianAvailabilityRulesUrl)(clinician.id),
      id: _utils2.CalendarGroup.RecurringAvailability,
      color: _utils2.ColorForCalendarGroup[_utils2.CalendarGroup.RecurringAvailability],
      display: 'background',
      success: function success(response) {
        setBlockingCalendarIds(response.calendarIds || []);
        return response.weeklyPeriods;
      },
      eventDataTransform: function eventDataTransform(period) {
        return {
          calendarGroup: _utils2.CalendarGroup.RecurringAvailability,
          daysOfWeek: [_utils.WEEKDAYS_ORDER_SUNDAY_START.indexOf(period.day)],
          startTime: period.startTime,
          endTime: period.endTime
        };
      }
    }];
  }, [clinician.id]);
  var getEventClassNames = (0, _react.useCallback)(function (_ref2) {
    var extendedProps = _ref2.event.extendedProps;
    if (!showCalendarsSet.has(extendedProps.calendarGroup)) {
      return 'hidden';
    }
    // For any real events (not availability blocks) - hide if they don't belong to a blocking calendar
    if (extendedProps.calendarId) {
      if (!isBlockingCalendar(extendedProps.calendarId)) {
        return 'hidden';
      }
    }
    return null;
  }, [showCalendars, blockingCalendarIds]);
  if (loadingCalendars) {
    return /*#__PURE__*/_react.default.createElement(_.SpinPlaceholder, {
      spinning: true
    });
  }

  // After testing some variants, doing it like this instead of passing a 'url' value in eventDataTransform
  // since it is already wrapped in <a> tag outside and that one does not have options to open in new tab
  // Not using <Link> in render method for the same reason, since nested links are a bad practice
  var handleEventClick = function handleEventClick(eventInfo) {
    var _calendarEventToAppoi = (0, _utils2.calendarEventToAppointmentData)(eventInfo),
      patient = _calendarEventToAppoi.patient,
      extendedProps = _calendarEventToAppoi.extendedProps;
    var isBlockingEvent = extendedProps.calendarGroup === _utils2.CalendarGroup.BlockingEvents;
    if (eventInfo.jsEvent) {
      eventInfo.jsEvent.preventDefault();
      eventInfo.jsEvent.stopPropagation();
    }
    // No navigation to patient details for external events
    if (isBlockingEvent) {
      return;
    }
    if (patient) {
      var navigateToPatient = "".concat(process.env.REACT_APP_APPLICATION_URL).concat(process.env.PUBLIC_URL, "/patients/").concat(patient.nickName, "/info");
      window.open(navigateToPatient, '_blank');
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "clinician-calendar"
  }, /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: fetching
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-row h-[calc(100vh-210px)]"
  }, /*#__PURE__*/_react.default.createElement(_components.SideMenu, {
    showCalendarsSet: showCalendarsSet,
    clinician: clinician,
    blockingCalendars: blockingCalendars
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "ml-4 flex-auto"
  }, /*#__PURE__*/_react.default.createElement(_react2.default, _extends({}, fcConfig, {
    timeZone: clinician.timeZone,
    customButtons: customButtons,
    initialView: "timeGridWeek",
    eventSources: eventSources,
    eventClassNames: getEventClassNames,
    allDaySlot: true,
    nowIndicator: true,
    scrollTime: "08:00",
    slotLabelInterval: "01:00",
    slotDuration: "00:15:00",
    datesSet: handleDatesSet,
    loading: setFetching,
    eventContent: function eventContent(eventInfo) {
      return /*#__PURE__*/_react.default.createElement(_components.CalendarEventCardContent, {
        onExtendAppointment: function onExtendAppointment() {
          return setAppointmentToExtend(eventInfo.event.extendedProps);
        },
        eventInfo: eventInfo,
        calendars: calendars,
        clinician: clinician
      });
    },
    eventClick: handleEventClick,
    ref: calendarRef
  }))))), /*#__PURE__*/_react.default.createElement(_.ExtendAppointmentCubby, {
    booking: appointmentToExtend ? {
      startsAt: appointmentToExtend.startsAt,
      intervalFrequency: appointmentToExtend.intervalFrequency,
      id: appointmentToExtend.bookingId
    } : null,
    onClose: function onClose() {
      return setAppointmentToExtend(null);
    },
    onSuccess: refreshCalendar
  }));
};
exports.ClinicianCalendar = ClinicianCalendar;